import { Link } from "react-router-dom";
import FeatureBlocks from "../components/FeatureBlocks/FeatureBlocks";
import { IconCalendar, IconSearchGlass, IconCloseBold, IconTagSingleBold } from "../assets/icons";

const HomePage = () => {
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 100px)'
        }}>
            <div style={{
                textAlign: 'center',
                marginBottom: '40px',
                width: '100%',
                maxWidth: '800px',
                padding: '2rem',
                margin: '0 auto'
            }}>
                <h1>DimeDock</h1>
                <p style={{
                    fontSize: '1.2rem',
                    color: '#282828'
                }}>
                    Welcome to DimeDock! We're here to help you take control of your finances. Get started by adding your accounts, and we'll help you build a budget, pay off your debt, and save money on your existing bills.
                </p>
            </div>
            <FeatureBlocks
                data={[
                    {
                        backgroundColor: "#eef5ff",
                        title: "Monitor Your Accounts",
                        description: "All your accounts in one place. See your financial picture.",
                        icon: <IconSearchGlass fill="#282828" />,
                        link: "/accounts",
                        linkText: "Add Your Accounts"
                    },
                    {
                        backgroundColor: "#10b981",
                        title: "Budget With Clarity",
                        description: "Setting a new budget every month is a pain. We'll help you automate it by setting up recurring transactions you can easily adjust as needed.",
                        icon: <IconCalendar fill="#282828" />,
                        link: "/transactions",
                        linkText: "Manage Your Transactions"
                    },
                    {
                        backgroundColor: "#00a4b3",
                        title: "Destroy Your Debt",
                        description: "Our debt snowball tool will help you create a plan to pay off your debt quickly. It even creates the transactions for you and adds them to your budget!",
                        icon: <IconCloseBold fill="#282828" />,
                        link: "/tools/debt-snowball",
                        linkText: "Get Free From Debt"
                    },
                    {
                        backgroundColor: "#a4b300",
                        title: "Save on Existing Bills",
                        description: "We'll analyze your spending and help you find better deals on the services you already use. A little tinkering can save you a lot of money over time.",
                        icon: <IconTagSingleBold fill="#282828" />,
                        link: "/budget-optimizer",
                        linkText: "Optimize Your Budget"
                    }
                ]}
            />

            <div style={{
                textAlign: 'center',
                marginBottom: '40px',
                width: '100%',
                maxWidth: '800px',
                padding: '2rem',
                margin: '0 auto'
            }}>
                <h2>Need Help Getting Started?</h2>

                <p style={{
                    fontSize: '1.2rem',
                    color: '#282828'
                }}>
                    Check out our <Link to="/help-center" className="text-link">Help Center</Link> for step-by-step instructions, or <Link to="/support" className="text-link">contact us</Link> for personalized assistance.
                </p>
            </div>
        </div>
    );
};

export default HomePage;
